import { useRef, useEffect } from 'react'

export const useInfiniteScroll = (fetchNextPage, hasNextPage) => {
  const mobileScrollContainerRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      const container = mobileScrollContainerRef.current
      if (!container) return

      const { scrollTop, scrollHeight, clientHeight } = container
      if (scrollTop + clientHeight >= scrollHeight - 50 && hasNextPage) {
        fetchNextPage()
      }
    }

    const container = mobileScrollContainerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [fetchNextPage, hasNextPage])

  return mobileScrollContainerRef
}
